import type * as React from "react";

import { cn } from "../lib/cn";

export interface StickyNoteProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}

/** A memo: read once, acted on, thrown away. `wash-flag` is used as paper stock, not status. */
export function StickyNote({ children, className, ...rest }: StickyNoteProps) {
  return (
    <div
      className={cn(
        "relative min-h-40 rounded-none bg-wash-flag p-4 font-body text-ink shadow-lift",
        className,
      )}
      {...rest}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-5 bg-ink/5"
      />
      <div className="relative">{children}</div>
    </div>
  );
}
